
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Globe, Mail, Phone } from "lucide-react";

interface BasicInfoSectionProps {
  formData: {
    orgName: string;
    linkedIn: string;
    facebook: string;
    twitter: string;
    instagram: string;
    email: string;
    phone: string;
  };
  onChange: (key: string, value: string) => void;
  isLoading: boolean;
}

export function BasicInfoSection({ formData, onChange, isLoading }: BasicInfoSectionProps) {
  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="orgName">Organization Name</Label>
        <Input
          id="orgName"
          placeholder="Enter your organization name"
          value={formData.orgName}
          onChange={(e) => onChange("orgName", e.target.value)}
          className="mt-1.5"
          disabled={isLoading}
        />
      </div>

      <div>
        <Label htmlFor="website">Your Website URL</Label>
        <div className="mt-1.5 relative">
          <Globe className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 h-5 w-5" />
          <Input
            id="website"
            type="url"
            placeholder="www.yournonprofit.org"
            className="pl-10"
            disabled={isLoading}
          />
        </div>
      </div>

      <div>
        <Label htmlFor="email">Email Address</Label>
        <div className="mt-1.5 relative">
          <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 h-5 w-5" />
          <Input
            id="email"
            type="email"
            placeholder="contact@yournonprofit.org"
            value={formData.email}
            onChange={(e) => onChange("email", e.target.value)}
            className="pl-10"
            disabled={isLoading}
          />
        </div>
      </div>

      <div>
        <Label htmlFor="phone">Phone Number</Label>
        <div className="mt-1.5 relative">
          <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 h-5 w-5" />
          <Input
            id="phone"
            type="tel"
            placeholder="+1 (555) 000-0000"
            value={formData.phone}
            onChange={(e) => onChange("phone", e.target.value)}
            className="pl-10"
            disabled={isLoading}
          />
        </div>
      </div>

      <div className="space-y-4">
        <Label>Social Media Profiles</Label>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            placeholder="LinkedIn Profile"
            value={formData.linkedIn}
            onChange={(e) => onChange("linkedIn", e.target.value)}
            disabled={isLoading}
          />
          <Input
            placeholder="Facebook Page"
            value={formData.facebook}
            onChange={(e) => onChange("facebook", e.target.value)}
            disabled={isLoading}
          />
          <Input
            placeholder="Twitter Profile"
            value={formData.twitter}
            onChange={(e) => onChange("twitter", e.target.value)}
            disabled={isLoading}
          />
          <Input
            placeholder="Instagram Profile"
            value={formData.instagram}
            onChange={(e) => onChange("instagram", e.target.value)}
            disabled={isLoading}
          />
        </div>
      </div>
    </div>
  );
}
